import { firstTag, tagValue } from "./tags.ts";
import type { OsmTags } from "./types.ts";

export function displayName(tags: OsmTags): string | undefined {
  const name = firstTag(tags, ["name", "name:en"]);
  if (name) return name;

  if (tagValue(tags, "amenity") === "atm") {
    return firstTag(tags, ["operator", "network"]);
  }
  if (
    tagValue(tags, "amenity") === "parcel_locker" ||
    tagValue(tags, "amenity") === "charging_station"
  ) {
    const owner = firstTag(tags, ["brand", "operator"]);
    const ref = firstTag(tags, ["ref"]);
    if (owner && ref) return `${owner} ${ref}`;
    return owner ?? ref;
  }

  return firstTag(tags, ["brand", "operator"]);
}
